<template>
  <div>
    <img class="operation_icon" width="30" src="/black_x.png" @click="rejectOffer" />
    <div v-if="mutable_offer" class="is-flex is-align-items-center">
      <offer-status :payload="mutable_offer"></offer-status>
      <div class="horizontal_space"></div>
      <a @click="cv()" class="button is-outlined is-info">CV</a>
      <div class="horizontal_space"></div>
      <a @click="aiEvaluate()" class="button is-outlined is-warning is-small" title="הערכת AI">AI</a>
      <div class="horizontal_space"></div>
      <p><b>DISTANCE:</b> {{ mutable_offer.distance }}</p>
      <div class="horizontal_space"></div>
      <message :payload="mutable_offer" :additional_data="{ resource_type: 'Offer', endpoint: '/offers/', headers: 'admin_headers' }">
      </message>
      <div class="horizontal_space"></div>
      <div class="horizontal_space"></div>
      <div style="min-width: 30px;">
        <WhatsAppLink :phoneNumber="mutable_offer.applicant.phone_number" :message="textWhatsApp"></WhatsAppLink>
      </div>
    </div>
    <div v-else dir="rtl" class="is-flex is-flex-direction-column is-align-items-center is-justify-content-center">
      <div :class="{ loading }"></div>
      <p>{{ messageText }}</p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'
import WhatsAppLink from '@/components/WhatsAppLink'
import Message from '@/components/Message'
import OfferStatus from '@/components/OfferStatus'
export default {
  name: 'related-offer',
  props: ['offer', 'position_id', 'applicant_id'],
  data () {
    return {
      offers_helper: new OffersHelper(),
      mutable_offer: this.offer,
      interval: {},
      intervalCounter: 0,
      messageText: 'טוען Offer. עלול לקחת כמה שניות...',
      loading: true
    }
  },
  computed: {
    textWhatsApp () {
      return `היי ${this.mutable_offer.applicant.first_name},\nאנחנו יוצרים איתך קשר בנוגע למשרה - ${this.mutable_offer.position.title}`
    }
  },
  mounted () {
    if (this.offer == undefined) {
      this.startTimer()
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    startTimer () {
      this.getOffer()
      this.interval = setInterval(this.getOffer, 5000)
    },
    aiEvaluate () {
      this.create({
        designator: 'ai-evaluation-modal-' + this.mutable_offer.id,
        component_name: 'AiEvaluationModal',
        data: this.mutable_offer,
        modal_title: 'הערכת AI',
        modal_width: 700,
        is_center_modal: true
      })
    },
    cv () {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data: this.mutable_offer,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    rejectOffer () {
      // The structured OfferRejectReasonModal (opened by offers_helper.rejectOffer)
      // is now the single reject prompt — it supersedes the old free-text
      // MessageForm reason that PUT offer.message.
      this.offers_helper.rejectOffer(this.mutable_offer)
    },
    getOffer () {
      this.intervalCounter++
      if (this.intervalCounter > 2) {
        clearInterval(this.interval)
        this.messageText = 'לא נמצאה הצעה'
        this.loading = false
        return
      }
      this.$network_utils.getOfferBy({ applicant_id: this.applicant_id, position_id: this.position_id }).then(response => {
        let offer = response[0]
        if (offer == undefined) {
          return
        }
        this.mutable_offer = offer
        clearInterval(this.interval)
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    WhatsAppLink,
    Message,
    OfferStatus
  }
}
</script>
